import BaseUseCase from "../../base_use_case.js";

class CurrentUserPaymentMethodUseCase extends BaseUseCase {

  execute() {
    return this.httpClient({
      ...this.requestConfig(),
      method: "get",
      url: `/api/v1/users/payment_methods/current_user`
    });
  }
}

const instance = new CurrentUserPaymentMethodUseCase();
export default instance;